import * as React from "react"
import { Redirect, Route, Switch } from "react-router"

import CV from "modules/cv"
import FrontPage from "modules/frontpage"

import "./App.css"



export default class App extends React.Component {
  render() {
    return (
        <Switch>
            <Route exact path="/" component={FrontPage} />
            <Route exact path="/cv" component={CV} />
            <Redirect to="/"/>
        </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.tsx